/** Operations desk accounts that may open /ops on TripMaster. */

function normalizeRole(value) {
  return String(value ?? "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
}

function isAdminFlag(value) {
  if (value === true || value === 1) return true;
  const text = String(value ?? "").trim().toLowerCase();
  return text === "true" || text === "1";
}

export function canAccessTripMasterOps(user) {
  if (!user || typeof user !== "object") return false;
  const role = normalizeRole(user.role ?? user.agentRole);
  if (role === "operation" || role === "admin" || role === "super_admin") return true;
  const usertype = normalizeRole(user.usertype ?? user.userType);
  if (usertype === "admins" || usertype === "admin" || usertype === "super_admin") return true;
  return isAdminFlag(user.is_admin ?? user.isAdmin);
}
